export default "__VITE_ASSET__XBp4$EFo__"